import { instance } from './index';

export const GetPricelists = () => instance.get('/price-list/count-users');

export const UpdateUserPriceList = (id: number, userId: number) => instance.get(`/price-list/${id}/user/${userId}`);

export const GetUserPriceListById = (userId: number) => instance.get(`/price-list/${userId}/userId`);

export const GetPriceListById = (id: number) => instance.get(`/price-list/${id}`);
